import { useCallback, useState } from "react";
import { TbCheck, TbCopy } from "react-icons/tb";

export const CrossborderCopyButton = ({ value, ariaLabel }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback(
    async (event) => {
      event?.stopPropagation?.();
      if (!value) return;

      try {
        await navigator.clipboard.writeText(value);
        setCopied(true);
        window.setTimeout(() => setCopied(false), 2000);
      } catch {
        /* clipboard unavailable */
      }
    },
    [value]
  );

  return (
    <button
      type="button"
      onClick={handleCopy}
      className="inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-md border border-gray-200 bg-white text-gray-500 transition hover:border-[#e7a73f]/40 hover:bg-brand-cream hover:text-[#9a7340] dark:border-brand-dark-border dark:bg-brand-dark-elevated dark:text-gray-400 dark:hover:border-brand-gold-mid/40 dark:hover:bg-[#1f1f1f] dark:hover:text-brand-gold-mid"
      aria-label={ariaLabel}
    >
      {copied ? <TbCheck className="h-3 w-3 text-emerald-600" /> : <TbCopy className="h-3 w-3" />}
    </button>
  );
};
